import React, { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
  backupComponent?: ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return this.props.backupComponent ?? <></>;
    }
    return this.props.children;
  }
}
